<section *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" novalidate [formGroup]="formInvoicingModel">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
                (onClick)="deleteInvoicingModel()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createInvoicingModel()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="invoicingModelContract.userNameCreate"
                [createDate]="invoicingModelContract.createDate"
                [userNameUpdate]="invoicingModelContract.userNameUpdate"
                [updateDate]="invoicingModelContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row d-flex justify-content-between">
            <div class="row">
              <div class="col-lg-12">
                <div class="row pe-md-3 py-md-2">
                  <div class="col field-consecutive">
                    <app-custom-input-number formControlName="consecutive" [labelText]="'Modelo'" [required]="true"
                      [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                  </div>
                  <div class="col field-description">
                    <app-custom-input-text formControlName="description" [labelText]="'Descripción'" [required]="true"
                      [maxLength]="250">
                    </app-custom-input-text>
                  </div>
                  <div class="col field-tag">
                    <app-custom-tag [value]="labelModel"></app-custom-tag>
                  </div>
                  <div class="col field-send d-flex justify-content-end align-items-end mt-2">
                    <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                      [disabled]="disabledForm" (onClick)="send()">
                    </app-custom-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-invoicing-model-detail [invoicingModelModel]="invoicingModelContract" [disabledDetail]="disabledDetail"
      [updateListDetail]="updateListDetail" (updateList)="getUpdateListDetail()"
      (emitQuantityDetails)="getQuantityDetails($event)"></app-invoicing-model-detail>
  </div>
</section>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>